import { Button, DatePicker, Input, InputNumber, Modal, Select, Upload } from "antd";
import { useEffect, useState } from "react";

import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { saveExpertise, updateExpertise } from "../../../hooks/useHooks";
import axiosInstance from "../../../variables/api/axiosInstance";
import { DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { ITT_UNITS } from "../../../variables/constants";
import { convertIttValueToDays, formatIttValueForDisplay, getIttUnitLabel } from "../../../variables/functions";

import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const { TextArea } = Input;

const parseDateValue = (value) => {
    if (!value) {
        return null;
    }
    const candidate = dayjs(value);
    return candidate?.isValid?.() ? candidate : null;
};

const resolveMissionTitle = (data = {}) => {
    const candidates = [
        data.objetMission,
        data.objet,
        data.intitule,
        data.intituleMission,
        data.intituleObjetMission,
        data.libelleMission,
        data.titre,
        data.description,
    ];
    const found = candidates.find((item) => typeof item === "string" && item.trim().length);
    return found ? found.trim() : "";
};

const normalizeBooleanOption = (value) => {
    if (value === null || value === undefined) {
        return value;
    }
    if (value === true) {
        return "OUI";
    }
    if (value === false) {
        return "NON";
    }
    return value;
};

const AjouterExpertise = (props) => {
    const [modalExpert, setModalExpert] = useState(false);
    const [expertise, setExpertise] = useState({});
    const [ittUnit, setIttUnit] = useState("JOURS");
    const [ittDays, setIttDays] = useState(0);
    const [ittRawValue, setIttRawValue] = useState("0");

    const [nomState, setNomState] = useState("");
    const [victimeState, setVictimeState] = useState("");
    const [expertState, setExpertState] = useState("");
    const [typeExpertiseState, setTypeExpertiseState] = useState("");
    // const [fonctionState, setFonctionState] = useState("");
    const [commentaireState, setCommentaireState] = useState("");
    const [documents, setDocuments] = useState([]);

    const [points, setPoints] = useState([]);

    const isValidated = () => {
        if (
            nomState === "success" &&
            victimeState === "success" &&
            expertState === "success" &&
            typeExpertiseState === "success" &&
            // fonctionState === "success" &&
            commentaireState === "success"
        ) {
            return true;
        } else {
            if (nomState !== "success") {
                setNomState("error");
            }
            if (victimeState !== "success") {
                setVictimeState("error");
            }
            if (expertState !== "success") {
                setExpertState("error");
            }
            if (typeExpertiseState !== "success") {
                setTypeExpertiseState("error");
            }
            // if (fonctionState !== "success") {
            //     setFonctionState("error");
            // }
            if (commentaireState !== "success") {
                setCommentaireState("error");
            }
            return false;
        }
    };

    const [addVictimeLoading, setAddVictimeLoading] = useState(false)

    const handleSubmit = async () => {
        const validated = isValidated();
        console.log(expertise);
        console.log("documents", documents);
        if (!validated) {
            toast.error("Veuillez remplir tous les champs obligatoires");
            return;
        }

        const docs = documents.flatMap((item) => item.originFileObj);
        console.log("docs", docs);

        const formatPickerValue = (pickerValue) =>
            pickerValue && typeof pickerValue.format === "function"
                ? pickerValue.format("YYYY-MM-DD")
                : pickerValue;

        const expertisePayload = { ...(expertise || {}) };
        expertisePayload.dateExpertise = formatPickerValue(expertisePayload.dateExpertise);
        expertisePayload.dateConsolidation = formatPickerValue(expertisePayload.dateConsolidation);
        expertisePayload.dateDernierSalaire = formatPickerValue(expertisePayload.dateDernierSalaire);

        const missionTitle = (expertisePayload.objetMission || "").toString().trim();
        if (missionTitle) {
            expertisePayload.objetMission = missionTitle;
            if (!expertisePayload.objet || typeof expertisePayload.objet !== "string" || !expertisePayload.objet.trim()) {
                expertisePayload.objet = missionTitle;
            }
            if (!expertisePayload.intitule || typeof expertisePayload.intitule !== "string" || !expertisePayload.intitule.trim()) {
                expertisePayload.intitule = missionTitle;
            }
            if (
                !expertisePayload.intituleMission ||
                typeof expertisePayload.intituleMission !== "string" ||
                !expertisePayload.intituleMission.trim()
            ) {
                expertisePayload.intituleMission = missionTitle;
            }
        }

        if (typeof expertisePayload.besoinAssistance === "string") {
            expertisePayload.besoinAssistance = expertisePayload.besoinAssistance === "OUI";
        }

        if (typeof expertisePayload.prejudiceCarriere === "string") {
            expertisePayload.prejudiceCarriere = expertisePayload.prejudiceCarriere === "OUI";
        }

        if (typeof expertisePayload.perceptionSalairePendantTraitement === "string") {
            expertisePayload.perceptionSalairePendantTraitement =
                expertisePayload.perceptionSalairePendantTraitement === "OUI";
        }

        expertisePayload.itt = ittDays;
        expertisePayload.ittUnit = ittUnit;

        const formData = new FormData();
        formData.append("expertise", new Blob([JSON.stringify(expertisePayload)], { type: "application/json" }));
        docs.forEach(file => {
            formData.append("documents", file);
        });
        formData.append("sinistreId", props.sinistre.codeId);
        console.log("formData", formData);
        if (props.edit) {
            const expertiseCodeId = props.expertise?.codeId ?? props.expertise?.id;
            if (!expertiseCodeId) {
                toast.error("Impossible d'identifier l'expertise à modifier");
                return;
            }
            const payloadWithId = {
                ...expertisePayload,
                codeId: expertiseCodeId,
            };
            // console.log("payloadWithId", payloadWithId);

            updateExpertise(payloadWithId)
                .then((res) => {
                    console.log(res.data);
                    toast.success("Expertise modifiée avec succès");
                    window.location.reload();
                })
                .catch((error) => {
                    console.log(error);
                    toast.error("Erreur lors de la modification de l'expertise");
                });
        } else {
            try {
                setAddVictimeLoading(true)

                await saveExpertise(formData);
                toast.success('Expertise ajoutée avec succès !');
                console.log(expertisePayload)
                setAddVictimeLoading(false);
                window.location.reload();

            } catch (error) {
                toast.error('Une erreur est survenue')
                setAddVictimeLoading(false)

            } finally {
                setAddVictimeLoading(false)
            }

        }
    };

    const handleChange = (e, nom) => {
        setExpertise((prev) => {
            const current = prev || {};
            if (nom) {
                return { ...current, [nom]: e };
            }
            const { name, value } = e.target;
            return { ...current, [name]: value };
        });
    };

    const syncExpertiseItt = (days, unitValue) => {
        setExpertise((prev) => ({ ...(prev || {}), itt: days, ittUnit: unitValue }));
    };

    const handleIttValueChange = (event) => {
        const { value } = event.target;
        setIttRawValue(value);

        const numericValue = parseFloat(value);
        if (Number.isNaN(numericValue)) {
            setIttDays(0);
            syncExpertiseItt(0, ittUnit);
            return;
        }

        const days = convertIttValueToDays(numericValue, ittUnit);
        setIttDays(days);
        syncExpertiseItt(days, ittUnit);
    };

    const handleIttUnitChange = (unitValue) => {
        setIttUnit(unitValue);
        setIttRawValue(formatIttValueForDisplay(ittDays, unitValue));
        syncExpertiseItt(ittDays, unitValue);
    };

    useEffect(() => {
        setModalExpert(props.open);
    }, [props.open]);

    useEffect(() => {
        if (props.edit && props.expertise) {
            const unit = props.expertise.ittUnit || "JOURS";
            const parsedDays = parseFloat(props.expertise.itt ?? 0);
            const days = Number.isNaN(parsedDays) ? 0 : parsedDays;
            const expertiseData = { ...props.expertise };

            expertiseData.objetMission = resolveMissionTitle(expertiseData);
            expertiseData.dateExpertise = parseDateValue(
                expertiseData.dateExpertise || expertiseData.dateEvaluation || expertiseData.createdAt
            );
            expertiseData.dateConsolidation = parseDateValue(expertiseData.dateConsolidation);
            expertiseData.dateDernierSalaire = parseDateValue(expertiseData.dateDernierSalaire);
            expertiseData.besoinAssistance = normalizeBooleanOption(expertiseData.besoinAssistance);
            expertiseData.prejudiceCarriere = normalizeBooleanOption(expertiseData.prejudiceCarriere);
            expertiseData.perceptionSalairePendantTraitement = normalizeBooleanOption(
                expertiseData.perceptionSalairePendantTraitement
            );

            setExpertise({ ...expertiseData, itt: days, ittUnit: unit });
            setIttUnit(unit);
            setIttDays(days);
            setIttRawValue(formatIttValueForDisplay(days, unit));
            setNomState(expertiseData.objetMission ? "success" : "");
            setVictimeState(expertiseData?.beneficiaire ? "success" : "");
            setExpertState(expertiseData?.expert ? "success" : "");
            setTypeExpertiseState(expertiseData?.typeExpertise ? "success" : "");
            setCommentaireState(expertiseData?.commentaire ? "success" : "");
        } else if (!props.edit && modalExpert) {
            const unit = "JOURS";
            const days = 0;
            setExpertise({ itt: days, ittUnit: unit });
            setIttUnit(unit);
            setIttDays(days);
            setIttRawValue(formatIttValueForDisplay(days, unit));
        }
    }, [props.expertise, props.edit, modalExpert]);

    useEffect(() => {
        if (!modalExpert) {
            props.setOpen(false);
        }
    }, [modalExpert]);

    const uploadProps = {
        action: '/',
        onChange({ file, fileList }) {
            if (file.status !== 'uploading') {
                // console.log(file, fileList);
                setDocuments(fileList);
            }
        },
        showUploadList: {
            extra: ({ size = 0 }) => (
                <span style={{ color: '#cccccc' }}>({(size / 1024 / 1024).toFixed(2)}MB)</span>
            ),
            showDownloadIcon: true,
            downloadIcon: 'Download',
            showRemoveIcon: true,
            removeIcon: <DeleteOutlined onClick={e => console.log(e, 'custom removeIcon event')} />,
        },
    };

    useEffect(() => {
        axiosInstance.get(`/api/pretium-doloris`)
            .then(res => {
                console.log(res.data)
                setPoints(res.data)
            }).catch(err => {
                console.log(err)
            });
    }, []);

    return (
        <Modal
            title={props.edit ? "Modifier une expertise" : "Ajouter une expertise"}
            centered
            open={modalExpert}
            onOk={() => handleSubmit()}
            onCancel={() => setModalExpert(false)}
            loading={addVictimeLoading}
            confirmLoading={addVictimeLoading}
            width={1200}
            okText={props.edit ? "Modifier" : "Ajouter"}
            cancelText="Annuler"
            zIndex={2000}
        >
            <div className="row" >
                <div className="col-12">
                    <label
                        htmlFor="nom"
                        style={{
                            margin: "30px 0 10px 0",
                            color: nomState === "error" ? "red" : null,
                        }}
                    >

                        Intitulé de l{"'"}expertise / Objet de la mission d'expertise: *
                    </label>
                    <Input
                        id="objetMission"
                        name="objetMission"
                        placeholder="Intitulé de l'expertise"
                        value={expertise?.objetMission || ""}
                        status={nomState === "error" ? "error" : null}
                        onChange={(event) => {
                            handleChange(event);
                            if (event.target.value.length > 3) {
                                setNomState("success");
                            } else {
                                setNomState("error");
                            }
                        }}
                    />
                </div>
                <div className="col-4">
                    <label
                        htmlFor="beneficiaire"
                        style={{
                            margin: "30px 0 10px 0",
                            color: victimeState === "error" ? "red" : null,
                        }}
                    >
                        Victime : *
                    </label>
                    <Select
                        id="beneficiaire"
                        name="beneficiaire"
                        style={{ width: "100%" }}
                        placeholder="Sélectionnez la victime"
                        options={(props?.sinistre?.victimes || []).map((item) => ({
                            value: item?.codeId,
                            label: item?.personne?.prenom ? `${item?.personne?.nom || ""} ${item?.personne?.prenom}`.trim() : item?.personne?.nom,
                        }))}
                        value={expertise?.beneficiaire?.codeId ?? undefined}
                        onChange={(value) => {
                            const selectedVictime = (props?.sinistre?.victimes || []).find((item) => item?.codeId === value);
                            handleChange(selectedVictime || null, "beneficiaire");
                            if (value) {
                                setVictimeState("success");
                            } else {
                                setVictimeState("error");
                            }
                        }}
                    />
                </div>
                <div className="col-4">
                    <label
                        htmlFor="typeExpertise"
                        style={{
                            margin: "30px 0 10px 0",
                            color: typeExpertiseState === "error" ? "red" : null,
                        }}
                    >
                        Type d{"'"}expertise : *
                    </label>
                    <Select
                        id="typeExpertise"
                        name="typeExpertise"
                        style={{ width: "100%" }}
                        placeholder="Sélectionnez le type d'expertise"
                        options={[{
                            value: 'MECANIQUE',
                            label: 'MECANIQUE'
                        }, {
                            value: 'MEDICALE',
                            label: 'MEDICALE'
                        }, {
                            value: 'JUDICIAIRE',
                            label: 'JUDICIAIRE'
                        }]}
                        value={expertise?.typeExpertise}
                        onChange={(value) => {
                            console.log(value);
                            handleChange(value, "typeExpertise");
                            value && setTypeExpertiseState("success");
                        }}
                    />
                </div>
                <div className="col-4">
                    <label
                        htmlFor="dateExpertise"
                        style={{ margin: "30px 0 10px 0" }}
                    >
                        Date de l'expertise *
                    </label>

                    <DatePicker
                        name="dateExpertise"

                        // ✅ valeur correctement parsée
                        value={
                            expertise?.dateExpertise
                                ? dayjs(expertise.dateExpertise, "DD/MM/YYYY")
                                : null
                        }

                        // ✅ gestion propre de la saisie
                        onChange={(date, dateString) => {
                            handleChange(dateString, "dateExpertise"); // on stocke en string FR
                        }}

                        format="DD/MM/YYYY" // ✅ format français

                        style={{ width: "100%" }}

                        // ✅ bloque dates futures
                        disabledDate={(current) =>
                            current && current > dayjs().endOf("day")
                        }

                        placeholder="JJ/MM/AAAA"

                        inputReadOnly={false} // ✅ autorise la saisie clavier
                    />
                </div>
                <div className="col-4">
                    <label
                        htmlFor="itt"
                        style={{
                            margin: "10px 0 10px 0",
                            // margin: "30px 0 10px 0", --- IGNORE ---
                            color: null,
                        }}
                    > ITT en nombre de {getIttUnitLabel(ittUnit).toLowerCase()}
                    </label>
                    <div className="d-flex gap-2">
                        <Input
                            placeholder={`ITT en nombre de ${getIttUnitLabel(ittUnit).toLowerCase()}`}
                            name={"itt"}
                            value={ittRawValue}
                            onChange={handleIttValueChange}
                            type='number'
                            min='0'
                            step='0.01'
                        />
                        <Select
                            value={ittUnit}
                            onChange={handleIttUnitChange}
                            options={ITT_UNITS}
                            style={{ minWidth: "120px" }}
                        />
                    </div>
                </div>
                <div className="col-4">
                    <label
                        htmlFor="ipp"
                        style={{ margin: "10px 0 10px 0" }}
                    >
                        Taux IPP en %
                    </label>

                    <InputNumber
                        placeholder="IPP en pourcentage"
                        name="ipp"
                        value={expertise?.ipp}
                        onChange={(value) => handleChange(value, "ipp")}

                        style={{ width: '100%' }}

                        // ✅ Contraintes métier
                        min={0}
                        max={100}
                        precision={2}

                        // ✅ Affichage propre
                        formatter={(value) =>
                            value !== undefined && value !== null
                                ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                : ''
                        }

                        parser={(value) =>
                            value ? value.replace(/,/g, '') : ''
                        }
                    />
                </div>
                <div className="col-4">
                    <label
                        htmlFor="pretiumDoloris"
                        style={{
                            margin: "10px 0 10px 0",
                            // margin: "30px 0 10px 0", --- IGNORE ---
                            color: null,
                            width: "100%"
                        }}
                    > Pretium Doloris
                    </label>
                    <Select
                        label={`Pretium Doloris`}
                        name={"pretiumDoloris"}
                        value={expertise?.pretiumDoloris || ""}
                        onChange={(event) => handleChange(event, "pretiumDoloris")}
                        options={points.map((item) => ({
                            value: item.points,
                            label: item.qualification
                        }))}
                        style={{ width: "100%" }}
                    />
                </div>
                <div className="col-4">
                    <label
                        htmlFor="prejudiceEsthetique"
                        style={{
                            margin: "10px 0 10px 0",
                            // margin: "30px 0 10px 0", --- IGNORE ---
                            color: null,
                            width: "100%"
                        }}
                    > Préjudice Esthétique
                    </label>
                    <Select
                        placeholder={`Préjudice Esthétique`}
                        name={"prejudiceEsthetique"}
                        value={expertise?.prejudiceEsthetique || ""}
                        onChange={(event) => handleChange(event, "prejudiceEsthetique")}
                        options={points.map((item) => ({
                            value: item.points,
                            label: item.qualification
                        }))}
                        style={{ width: "100%" }}
                    />
                </div>
                {expertise?.beneficiaire?.blesseSinistre && <div className="col-4">
                    <label
                        htmlFor="dateConsolidation"
                        style={{
                            margin: "10px 0 10px 0",
                            // margin: "30px 0 10px 0", --- IGNORE ---
                            color: null,
                        }}
                    > Date de consolidation de la victime
                    </label>
                    <DatePicker
                        label={`Date de consolidation de la victime`}
                        name={"dateConsolidation"}
                        value={expertise?.dateConsolidation ?? null}
                        onChange={(date) => handleChange(date, "dateConsolidation")}
                        style={{ width: "100%" }}
                        disabledDate={(current) => current && current > dayjs().endOf("day")}
                        placeholder="Date de consolidation de la victime"
                    />
                </div>}
                <div className="col-4">
                    <label
                        htmlFor="perceptionSalairePendantTraitement"
                        style={{
                            margin: "10px 0 10px 0",
                            // margin: "30px 0 10px 0", --- IGNORE ---
                            color: null,
                            width: "100%"
                        }}
                    > La Victime a-t-elle perçu son salaire pendant son traitement ? Oui/Non
                    </label>
                    <Select
                        showSearch={true}
                        label={`La Victime a-t-elle perçu son salaire pendant son traitement ? Oui/Non`}
                        name={"perceptionSalairePendantTraitement"}
                        value={expertise?.perceptionSalairePendantTraitement || ""}
                        onChange={(event) => handleChange(event, "perceptionSalairePendantTraitement")}
                        style={{ width: "100%" }}
                        options={[{ label: "OUI", value: "OUI" }, { label: "NON", value: "NON" }]}
                    />
                </div>
                <div className="col-4">
                    <label
                        htmlFor="dateDernierSalaire"
                        style={{
                            margin: "10px 0 10px 0",
                            // margin: "30px 0 10px 0", --- IGNORE ---
                            color: null,
                        }}
                    > Date du dernier salaire perçu par la victime
                    </label>
                    <DatePicker
                        label={`Date du dernier salaire perçu par la victime blessée`}
                        name={"dateDernierSalaire"}
                        value={expertise?.dateDernierSalaire ?? null}
                        onChange={(date) => handleChange(date, "dateDernierSalaire")}
                        style={{ width: "100%" }}
                        disabledDate={(current) => current && current > dayjs().endOf("day")}
                        placeholder="Date du dernier salaire perçu par la victime blessée"
                    />
                </div>
                <div className="col-4">
                    <label
                        htmlFor="besoinAssistance"
                        style={{
                            margin: "10px 0 10px 0",
                            // margin: "30px 0 10px 0", --- IGNORE ---
                            color: null,
                            width: "100%"
                        }}
                    > Besoin d'assistance ? Oui/Non
                    </label>
                    <Select
                        showSearch={true}
                        label={`Besoin d'assistance ? Oui/Non`}
                        name={"besoinAssistance"}
                        value={expertise?.besoinAssistance || "NON"}
                        onChange={(event) => handleChange(event, "besoinAssistance")}
                        style={{ width: "100%" }}
                        options={[{ label: "OUI", value: "OUI" }, { label: "NON", value: "NON" }]}
                    />
                </div>

                <div className="col-4">
                    <label
                        htmlFor="prejudiceCarriere"
                        style={{
                            margin: "10px 0 10px 0",
                            // margin: "30px 0 10px 0", --- IGNORE ---
                            color: null,
                            width: "100%"
                        }}
                    > Préjudice de carrière ? Oui/Non
                    </label>
                    <Select
                        showSearch={true}
                        label={`Préjudice de carrière ? Oui/Non`}
                        name={"prejudiceCarriere"}
                        value={expertise?.prejudiceCarriere || "NON"}
                        onChange={(event) => handleChange(event, "prejudiceCarriere")}
                        style={{ width: "100%" }}
                        options={[{ label: "OUI", value: "OUI" }, { label: "NON", value: "NON" }]}
                    />
                </div>
                <div className="col-4">
                    <label
                        htmlFor="expert"
                        style={{
                            margin: "10px 0 10px 0",
                            color: expertState === "error" ? "red" : null,
                        }}
                    >
                        Expert : *
                    </label>
                    <Select
                        id="expert"
                        name="expert"
                        style={{ width: "100%" }}
                        placeholder="Sélectionnez l'expert"
                        options={(props?.sinistre?.experts || []).map((item) => ({
                            value: item?.codeId,
                            label: item?.prenom ? `${item?.nom || ""} ${item?.prenom}`.trim() : item?.nom,
                        }))}
                        value={expertise?.expert?.codeId ?? undefined}
                        onChange={(value) => {
                            const selectedExpert = (props?.sinistre?.experts || []).find((item) => item?.codeId === value);
                            handleChange(selectedExpert || null, "expert");
                            if (value) {
                                setExpertState("success");
                            } else {
                                setExpertState("error");
                            }
                        }}
                    />
                </div>

                <div className="col-6">
                    <label
                        htmlFor="expert"
                        style={{
                            margin: "10px 0 10px 0",
                            color: expertState === "error" ? "red" : null,
                        }}
                    >
                        Rapport *
                    </label>
                    <Upload style={{ width: '100%' }} {...uploadProps}>
                        <Button style={{ width: '100%' }} icon={<UploadOutlined />}> Téléversez le(s) document(s)</Button>
                    </Upload>
                </div>
                <div className="col-12">
                    <label
                        htmlFor="telephone"
                        style={{
                            margin: "30px 0 10px 0",
                            color: commentaireState === "error" ? "red" : null,
                        }}
                    >
                        Description / commentaire :
                    </label>
                    <TextArea
                        id="commentaire"
                        name="commentaire"
                        value={expertise?.commentaire}
                        placeholder="Commentaire de l'expertise"
                        status={commentaireState === "error" ? "error" : null}
                        onChange={(event) => {
                            handleChange(event);
                            if (event.target.value.length > 3) {
                                setCommentaireState("success");
                            } else {
                                setCommentaireState("error");
                            }
                        }}
                        rows={4}
                    />
                </div>
                <br />
                <br />
                <br />

            </div>
        </Modal>
    );
};

AjouterExpertise.propTypes = {
    open: PropTypes.bool,
    expertise: PropTypes.object,
    edit: PropTypes.bool,
    setOpen: PropTypes.func,
};

export default AjouterExpertise;
